import { Discont, DiscontStatus } from '@project/shared-types';
import { useMemo, useState } from "react";
import ArrowDownSVG from "../../../../assets/taiga-uikit/icons/arrow-down.svg?react";
import { Button } from "../../../../components/button/button";
import { Divider } from "../../../../components/Divider/Divider";
import { Text } from "../../../../components/texts/text";
import { _colorText, _size, _sizeText, _style } from "../../../../core/core";
import { DiscontCard } from "../../../../entities/discount/ui/DiscontCard/DiscontCard";
import { useOrder } from '../../../../entities/order/context/OrderContext';
import { OrderServiceFront } from '../../../../entities/order/model/order.service';
import "./OrderPayment.css";

interface OrderPaymentProps {
    is_desktop?: boolean // если он создан для мобильного устройства 
}


export const OrderPayment = ({
    is_desktop = false
}: OrderPaymentProps) => {

    const [isDetailDiscont, setIsDetailDiscont] = useState(false);
    const { form, service, price, disconts, setDisconts, handleCreateOrder } = useOrder();

    // Определяем, является ли устройство планшетом
    const isTablet = (() => {
        if (typeof window === "undefined") return false;
        const width = window.innerWidth;
        // Обычно планшеты имеют ширину экрана от 768 до 1024 пикселей
        return width <= 1024;
    })();
    const discont = useMemo(() => {
        return disconts.find((d) => d.status === DiscontStatus.OK);
    }, [disconts]);

    const handleChangeActive = (enabled: boolean, discont: Discont) => {
        setDisconts(prev => {
            return prev.map((d) => {
                if (d.id === discont.id) {
                    return { ...d, status: enabled ? "ok" as DiscontStatus : "wait" as DiscontStatus };
                }
                return d;
            });
        });
    }
    if (is_desktop && isTablet)
        return null;

    if (!is_desktop && !isTablet)
        return null;
    const discontSum = useMemo(() => {
        return OrderServiceFront.discontSum(price.currentPrice, discont, form.count);
    }, [discont, price, form.count]);
    const isValidSum = useMemo(() => {
        return OrderServiceFront.isValidSum(price.currentPrice, discont, form.count);
    }, [discont, price, form.count]);
    const countDiscont = useMemo(() => {
        return OrderServiceFront.countDiscont(service?.price_max || 0, price.currentPrice, form.count);
    }, [discont, service, price, form.count]);

    const totalPrice = useMemo(() => {
        return OrderServiceFront.totalPrice(service?.price_max || 0, form.count, discontSum, countDiscont);
    }, [price, form.count, service, discontSum, countDiscont]);
    return (
        <div className="order-payment">
            <div className="order-payment-disconts">
                {disconts.map((discont) => (
                    <DiscontCard discont={discont} onChangeActive={(e) => handleChangeActive(e, discont)} />
                ))}
            </div>
            <div className="order-payment-total">
                <div className="flex flex-row justify-between">
                    <Text size={_sizeText.s} color={_colorText.neutral}>{form.count} шт</Text>
                    <Text size={_sizeText.s} color={_colorText.neutral}>{OrderServiceFront.viewTotalMaxPrice((service?.price_max || 0), form.count)} ₽</Text>
                </div>
                <Divider />
                <div onClick={() => { setIsDetailDiscont(!isDetailDiscont) }} className={`flex flex-row justify-between cursor-pointer dicont-info-${isDetailDiscont}`}>
                    <Text size={_sizeText.s} color={_colorText.neutral}>Скидка <ArrowDownSVG /></Text>
                    <Text size={_sizeText.s} color={_colorText.neutral}>{discontSum + countDiscont} ₽</Text>
                </div>
                {isDetailDiscont && (
                    <>
                        <div className="flex flex-row justify-between">
                            <Text size={_sizeText.s} color={_colorText.neutral}>&#x2022; За количество</Text>
                            <Text size={_sizeText.s} color={_colorText.neutral}>{countDiscont} ₽</Text>
                        </div>
                        <div className="flex flex-row justify-between">
                            <Text size={_sizeText.s} color={_colorText.neutral}>&#x2022; Персональная</Text>
                            <Text size={_sizeText.s} color={_colorText.neutral}>{discontSum} ₽</Text>
                        </div>
                    </>
                )}
                {!isValidSum && discont && (
                    <div className="flex flex-row justify-between">
                        <Text size={_sizeText.s} color={_colorText.negative}>Не хватает {OrderServiceFront.viewFailTotalDiscont(price.currentPrice, discont, form.count)} ₽ для скидки</Text>
                    </div>
                )}
                <Divider />
                <div className="flex flex-row justify-between">
                    <Text size={_sizeText.xlb} >Итого</Text>
                    <Text size={_sizeText.xlb} >{totalPrice} ₽</Text>
                </div>
            </div>
            <Button size={_size.M} style={_style.secondary} className="order-payment-button" onClick={handleCreateOrder}>Оплатить и запустить</Button>
        </div>
    )
}